/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./transfer-setting.vue?vue&type=template&id=72a43beb&scoped=true&"
import script from "./transfer-setting.vue?vue&type=script&lang=ts&"
export * from "./transfer-setting.vue?vue&type=script&lang=ts&"
import style0 from "./transfer-setting.vue?vue&type=style&index=0&id=72a43beb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a43beb",
  null
  
)

export default component.exports